import React from 'react'
import { ModalPadraoCadastroCentral } from '../../../../../components/Modais'
import { BotaoPadrao } from '../../../../../components/Botoes'
import { InputPadrao, InputDatePicker } from '../../../../../components/Inputs'
import { InputEstabelecimentoSaude, InputContaBancariaEmpresa, InputContaBancariaCliente } from '../../../../../components/InputsAutoComplete'
import { InputCategoriaAlternativo, InputClienteFinanceiroV3, InputEmpresaClienteLancamento, InputModoLiquidacao } from '../../../../../components/InputsAutoCompleteV2'

const parseValorFormatado = (str) => {
    const s = (str || '').toString()
        .replace(/[^\d,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
    return parseFloat(s) || 0
}

const ModalDadosLancamentos = ({ propsFormik, showModal, setShowModal, salvando, modal, tabLancamento, id }) => {
    const guiasSelecionadas = propsFormik.values.guias || []
    const valorTotal = guiasSelecionadas
        .reduce((acc, g) => acc + parseValorFormatado(g.valor_total_formatado), 0)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

    return (
        <ModalPadraoCadastroCentral
            titulo={'Dados dos Lançamentos'}
            showModal={showModal}
            setShowModal={(val) => {
                setShowModal(val)
                if (!val) propsFormik.setFieldValue('tentouSalvarLancamento', false)
            }}>
            <div className='separator mb-3'></div>
            <div className='row mb-3 px-3'>
                <div className='col-6'>
                    <h6>Guia(s) Selecionada(s): <b>{guiasSelecionadas.length}</b></h6>
                </div>
                <div className='col-6 text-right'>
                    <h6>Valor Total: <b>{valorTotal}</b></h6>
                </div>
            </div>
            <div className='separator mb-4'></div>

            <div className='row'>
                <InputClienteFinanceiroV3
                    label="Cliente" name="cliente_lancamento" placeholder="Cliente"
                    propsFormik={propsFormik} obrigatorio={true} botaoVisivel={true} array={true}
                    tamanho={"col-lg-4"} classeTooltip={"tooltip-input-modal"}
                    onChange={(option) => {
                        propsFormik.setFieldValue("conta_bancaria_lancamento", null)
                        propsFormik.setFieldValue("cliente_lancamento", option)
                    }}
                />
                <InputEstabelecimentoSaude
                    label='Estabelecimento Saúde' name="estabelecimento_saude" placeholder="Estabelecimento Saúde"
                    propsFormik={propsFormik} tamanho={'col-lg-4'} classeTooltip={'tooltip-input-modal'}
                />
                <InputCategoriaAlternativo
                    utiliza_lancamento={true} setarSeForUm={tabLancamento || !id}
                    label='Categoria' name="categoria_lancamento" placeholder="Categoria"
                    propsFormik={propsFormik} obrigatorio={true}
                    tamanho={'col-lg-4'} array={true} classeTooltip={'tooltip-input-modal'} botaoVisivel={true}
                />
                <InputEmpresaClienteLancamento
                    label='Empresa' name="empresa" placeholder="Empresa" propsFormik={propsFormik}
                    tamanho={!modal && 'col-xl-2 col-lg-6 col-md-6'} classeTooltip={modal && 'tooltip-input-modal'} obrigatorio={true}
                    onChange={(option) => {
                        propsFormik.setFieldValue('conta_bancaria_lancamento_empresa', null)
                        propsFormik.setFieldValue('empresa', option)
                    }}
                />
                <InputContaBancariaEmpresa
                    label='Conta Bancária Empresa' name="conta_bancaria_lancamento_empresa" placeholder="Conta Bancária Empresa"
                    propsFormik={propsFormik} botaoVisivel={propsFormik.values?.empresa} modal
                    tamanho={!modal && 'col-lg-3'} classeTooltip={modal && 'tooltip-input-modal'}
                />
                <InputContaBancariaCliente
                    label='Conta Bancária Cliente' name="conta_bancaria_lancamento" placeholder="Conta Bancária Cliente"
                    propsFormik={propsFormik} botaoVisivel={propsFormik.values?.cliente_lancamento} modal
                    tamanho={!modal && 'col-lg-3'} classeTooltip={modal && 'tooltip-input-modal'}
                />
                <InputPadrao
                    label='Descrição' name='descricao_lancamento' type='text' placeholder='Descrição'
                    classeTooltip={'tooltip-input-modal'} tamanho={!modal && 'col-lg-4'}
                />
                <InputDatePicker
                    tamanho={'col-lg-2'} label="Previsão Vencimento" name="previsao_vencimento_lancamento"
                    type="text" obrigatorio="true"
                    setarValor={v => propsFormik.setFieldValue("previsao_vencimento_lancamento", v)}
                    classeTooltip={modal && 'tooltip-input-modal'} mostrarFeriado={true}
                    onBlurData={v => {
                        propsFormik.setFieldValue("liquidacao[0].data_liquidacao", v)
                        propsFormik.setFieldValue("liquida_parcela.data", v)
                    }}
                />
            </div>

            <div className="mt-2">
                <div className="modal-header">
                    <h5 className="modal-title"><span>Liquidação</span></h5>
                </div>
                <div className='separator mb-5'></div>
            </div>
            <div className='row'>
                <InputModoLiquidacao
                    label={'Modo Liquidação'} obrigatorio={true} placeholder='Modo Liquidação'
                    classeTooltip={'tooltip-input-modal'} rray={true}
                    name={`modo_liquidacao`} propsFormik={propsFormik}
                    tamanho="col-sm-3 8 col-xl-4 col-lg-2 col-md-2 pr-0"
                />
                <InputDatePicker
                    tamanho={'col-xl-2'} label={"Data Prevista"} name={`data_liquidacao`} alertaDiasAnteriores={45}
                    type="text" obrigatorio="true"
                    setarValor={v => propsFormik.setFieldValue(`data_liquidacao`, v)}
                    classeTooltip={modal && 'tooltip-input-modal'} mostrarFeriado={true} placeholder='Data'
                />
            </div>

            <div className='direita container-botoes mb-3 group-salvar-novo'>
                <BotaoPadrao
                    texto='Salvar' disabled={salvando} type='button'
                    click={async () => {
                        await propsFormik.setFieldValue('tentouSalvarLancamento', true)
                        propsFormik.submitForm()
                    }}
                    idTooltip={'salvarLancamentos'}
                />
            </div>
        </ModalPadraoCadastroCentral>
    )
}

export default ModalDadosLancamentos
